import { render, staticRenderFns } from "./EditReviewModal.vue?vue&type=template&id=52f345dc&scoped=true"
import script from "./EditReviewModal.vue?vue&type=script&lang=js"
export * from "./EditReviewModal.vue?vue&type=script&lang=js"
import style0 from "./EditReviewModal.vue?vue&type=style&index=0&id=52f345dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f345dc",
  null
  
)

export default component.exports